<template lang="html">
  <div class="checkout">
    <!--  BUG: codigo fixo -->
    <v-dialog v-model="dialog" scrollable max-width="300">
      <v-card>
        <v-card-title class="headline">Precauções</v-card-title>
        <v-card-text>
          É necessário desocupar o local no intervalo de tempo entre seis e oito horas. - Aguardar rigorosamente o tempo definido.<br><br>
          Crianças, pessoas idosas ou alérgicas, deverão observar um prazo específico, ou solicitar orientação médica.<br>
          - Evite lavar os locais nos 03 primeiros dias após a aplicação, bem como usar produtos à base de pinho, que podem neutralizar a ação dos inseticidas.<br><br>
          É possível o surgimento de insetos nos primeiros dias após a aplicação (o inseticida possui ação desalojante). Aguarde de 15 a 20 dias para a avaliação dos serviços.<br><br>
          - Insetos em geral têm hábitos noturnos; evite deixar restos de alimentos acessíveis a eles durante a noite.<br>
          - Em caso de nova infestação, durante o período de garantia, basta telefonar e agendar aplicação de reforço, sem qualquer custo adicional.
        </v-card-text>
        <v-card-actions>
          <v-checkbox color="green" v-model="aware">
            <span slot="label">Estou ciente</span>
          </v-checkbox> 
        </v-card-actions> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
             class="btn-hotsite"
             :loading="loadingOrderRequest"
             @click.native="loader = 'loading'"
             :disabled="!loadingOrderRequest && !aware"
             v-on:click='requestOrder'
             flat="flat">
             confirmar pedido
           </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-slide-x-transition mode="out-in">
    <div class="box-want"  v-if="client !== null">
      <div class="description">
       <strong>  {{ client.name }} </strong>, 
        seu condomínio passará por <strong> 
        {{ client.category }} </strong> pela empresa <strong> {{ client.business }} </strong>, conforme agendamento abaixo.
      </div>
    <v-layout row wrap class="realization-date pt-0">
      <v-flex class="text-xs-left">
        <strong>
          <v-icon>event</v-icon> Data:
        </strong>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-select
        :items="item.dates"
        v-model="dateChoosen"
        hide-details
        class="pt-0 hour-select"
        single-line
        prepend
        v-if="item.dates.length > 0"
        bottom
        >
        <template slot="selection" slot-scope="data">
          <span class="date">{{ data.item | formatDate }}</span>
        </template>
        <template slot="item" slot-scope="data">
          <div :key="JSON.stringify(data.formatDate)">
            {{ data.item | formatDate }}
          </div>
        </template>
        </v-select>
        <div class="" v-else>
          {{ item.dateSchedule | formatDate }}
        </div>
      </v-flex>

    </v-layout>
    <v-layout row wrap class="realization-date pt-0">
      <v-flex class="text-xs-left">
        <strong>
          <v-icon>business</v-icon> Unidade:
        </strong>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-select
        :items="client.unity"
        v-model="unityChoosen"
        hide-details
        class="pt-0 hour-select"
        single-line
        prepend
        v-if="unity.length !== 1"
        append-icon=""
        bottom
        >
        </v-select>
        <div class="" v-else>
          {{ client.unity[0] }}
        </div>
      </v-flex>

    </v-layout>
    <v-layout>
      <v-flex xs12 mt-2>
        <hr>
      </v-flex>
    </v-layout>
    <div class="more-description">
      Esse é o momento ideal para agendar o serviço.
    </div>
    <!-- PRICE -->    
    <v-layout slot="activator" row wrap class="realization-date mt-2 mb-2 pa-0">
      <v-flex class="text-xs-center" style="word-break: break-all;">
        <v-select
        :items="item.priceTable"
        v-model="itemChoosen"
        item-text="description"
        item-value="provider"
        hide-details
        class="pt-0"
        single-line
        bottom
        >
        </v-select>
      </v-flex>
    </v-layout>
    <template v-if="price !== priceRef">
      <div class="price">
        <div class="real-price">
          <div class="">
            De {{ priceRef | currency }}
          </div>
        </div>
        <div class="discount-price">
          <span >Por </span> {{ price | currency }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="price">        
        <div class="discount-price">
          {{ price | currency }}
        </div>
      </div>
    </template>

    <!-- date -->
    <v-layout class="realization-date mt-3 pa-0 mb-2" row wrap>
      <v-flex>
        <strong>
          <v-icon>access_time</v-icon> Escolha um horário:
        </strong>
      </v-flex>
      <v-flex>
        <v-select
          :items="avaliableSchedule"
          v-model="timeChoosen"
          hide-details
          class="pt-0 hour-select"
          single-line
          prepend
          append-icon=""
          bottom
          >
          <template slot="selection" slot-scope="data">
            <span class="time">{{ data.item | time }}</span>
          </template>
          <template slot="item" slot-scope="data">
            <div :key="JSON.stringify(data.item)">
              {{ data.item | time }}
            </div>
          </template>
        </v-select> 
      </v-flex>
    </v-layout>

    <!-- payment -->
    <template v-if="paymentsViewModel.length > 0">
      <v-layout row wrap class="realization-date pa-0 mb-2">
        <v-flex class="text-xs-left">
          <strong>
            <v-icon>payment</v-icon> Pagamento:
          </strong>
        </v-flex>
        <v-flex xs12 class="text-xs-center">
          <v-select
          :items="paymentsViewModel"
          v-model="paymentChoosen"
          hide-details
          item-text="description"
          item-value="id"
          class="text-xs-center"
          single-line
          prepend
          bottom
          >
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap mb-2>
        <v-flex class="text-xs-center alert--text">
          Pagamento realizado na visita
        </v-flex>
      </v-layout>
    </template>    
    <v-checkbox color="green" v-model="acceptance" hide-details light>
      <span slot="label">li e aceito: <CondicoesDeUso/></span>
    </v-checkbox>
    <v-btn
      large
      v-on:click='openDialog'
      class="btn-hotsite"
      block
      v-if="itemActive"
      >
      Confirmar pedido
      <span slot="loader" class="custom-loader">
        <v-icon light>cached</v-icon>
      </span>
    </v-btn>
    <v-btn
      large
      :disabled="true"
      class="btn-hotsite"
      block
      v-else
      >
      Oferta expirada
      <span slot="loader" class="custom-loader">
        <v-icon light>cached</v-icon>
      </span>
    </v-btn>
  </div>
  </v-slide-x-transition>

  <v-slide-y-reverse-transition mode="out-in">
    <Feedback
      :token="token"
      class="feedback-btn"
      v-if="!loadingCheckout"/>
  </v-slide-y-reverse-transition>

  </div>
</template>

<script>
import CondicoesDeUso from './CondicoesDeUso'
import Feedback from './Feedback'
import moment from 'moment'

export default {
  name: 'checkOut',
  props: ['token'],
  components: {
    CondicoesDeUso,
    Feedback
  },
  data () {
    return {
      dialog: false,
      showFeedbackBtn: true,
      aware: false
    }
  },
  computed: {
    paymentsViewModel () {
      const payment = this.item.paymentsViewModel.filter((elem) => {
        if (elem.idItem.indexOf(this.$store.getters.itemChoosen.id) !== -1) {
          return elem
        }
      })
      if (payment.length === 0) {
        this.$store.commit('updatePaymentChoosen', null)
      }
      return payment
    },
    acceptance: {
      get () {
        return this.$store.getters.acceptance
      },
      set (value) {
        this.$store.commit('updateAcceptance', value)
      }
    },
    dateChoosen: {
      get () {
        return this.$store.getters.dateChoosen
      },
      set (value) {
        this.$store.dispatch('choseDate', value)
      }
    },
    timeChoosen: {
      get () {
        return this.$store.getters.timeChoosen
      },
      set (value) {
        this.$store.commit('updateTimeChoosen', value)
      }
    },
    unityChoosen: {
      get () {
        return this.$store.getters.unityChoosen
      },
      set (value) {
        this.$store.commit('updateUnityChoosen', value)
      }
    },
    paymentChoosen: {
      get () {
        return this.$store.getters.paymentChoosen
      },
      set (value) {
        this.$store.commit('updatePaymentChoosen', value)
      }
    },
    itemChoosen: {
      get () {
        return this.$store.getters.itemChoosen
      },
      set (value) {
        this.$store.commit('updateItemChoosen', value)
      }
    },
    avaliableSchedule () {
      return this.$store.getters.avaliableSchedule
    },
    client () {
      return this.$store.getters.client
    },
    unity () {
      return this.$store.getters.unity
    },
    item () {
      return this.$store.getters.item
    },
    priceRef () {
      return this.$store.getters.itemChoosenPriceRef
    },
    itemDescription () {
      return this.$store.getters.itemChoosenDescription
    },
    price () {
      return this.$store.getters.itemChoosenPrice
    },
    selectPriceVariation () {
      return this.$store.getters.priceVariation
    },
    itemActive () {
      if (this.item === null) return
      let time = this.item.dates[0]
      time = time.split('T')[0]
      time = time + 'T' + this.avaliableSchedule[this.avaliableSchedule.length - 1]
      return moment(time).diff(moment()) > 0
    },
    loadingCheckout () {
      return this.$store.getters.loadingCheckout
    },
    loadingOrderRequest () {
      return this.$store.getters.loadingOrderRequest
    }
  },
  methods: {
    openDialog () {
      if (this.acceptance) {
        this.dialog = true
      } else {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Aceite as condições do uso'
        })
      }
    },
    requestOrder () {
      this.$store.dispatch('requestOrder', this.token)
    },
    notAvaliable (value) {
      return this.notAvaliableSchedules.indexOf(value) !== -1
    }
  },
  mounted () {
    this.$store.dispatch('getCupom', this.token)
    this.$store.dispatch('getAllInfo', this.token)
  },
  filters: {
    time (value) {
      return moment('2013-01-01T' + value).format('HH:mm')
    },
    formatDate (value) {
      return !value ? '' : moment(value).format('DD/MM/YYYY')
    },
    currency (value) {
      let newValue = 0
      if (typeof value !== 'number') {
        newValue = parseFloat(value.replace('.', '').replace(',', '.'))
      } else if (typeof value === 'number') {
        newValue = value
      } else {
        return ''
      }
      return newValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

<style lang="css" scoped>
.box-want{
  background: #fff;
  width: 320px;
  margin: auto;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 30px;
  border-radius: 20px;
  color: #49515c;
  font-size: 16px;
}
.time-item{
  font-size: 18px;
  color: #49515c;
  text-transform: capitalize;
}
.notAvaliable{
  text-decoration: line-through;
  color: #afafaf;
}
.item-name{
  color: #f59620;
  font-size: 20px;
  text-align: left;
  margin-top: 12px;
}
.realization-date{
  padding: 10px;
  font-size: 20px;
}
.description,.more-description{
  margin-top: 10px;
  margin-bottom: 10px;
}
.price{
  margin-bottom: 15px;
  padding: 5px;
  border: 1px solid #9a9a9a;
  text-align: center;
}
.real-price{
  position: relative;
  float: left;
  height: 30px;
  width: 100%;
}
.real-price>div{
  position: relative;
  width: fit-content;
  margin: auto;
}
.real-price>div::after{
  content: ' ';
  display: block;
  position: absolute;
  top: 15px;
  left: -5px;
  right: -5px;
  height: 1px;
  border-bottom: 1px dashed #c7c7c7;
  border-top: 1px dashed #c7c7c7;
}
.real-price{
  font-size: 20px;
  position: relative;
  color: #c7c7c7;
}
.discount-price{
  color:#f59620;
  font-size: 26px;
}
.alert--text{
  color:#f59620;
}
.realization-date i{
  position: relative;
  top: -2px;
}
.time{
  width: 100%;
  display: block;
  text-align: center;
  color: #49515c;
}
.date{
  width: 100%;
  display: block;
  text-align: right;
  color: #49515c;
}

.feedback-btn {
  position: fixed;
  right: 1em;
  bottom: 1.5em;
}

hr {
  margin-bottom: 15px;
}

@media all and (max-width: 720px) {
  .feedback-btn {
    position: relative;
    transform: translateX(1.5em);
  }
}
</style>



// WEBPACK FOOTER //
// Checkout.vue?74e2e37d